import React, { useContext, useEffect, useRef, useState } from "react";
import Sidebar from "../../components/Admin/Sidebar";
import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import * as Icon from "react-bootstrap-icons";
import { ToastContainer, toast } from "react-toastify";
import { UserContext } from "../../context/UserContext";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { FaFilePdf } from "react-icons/fa";
import Modal from "react-bootstrap/Modal";

const Userprofile = () => {
  const auth = useContext(UserContext);
  const { fetchUser } = useContext(UserContext);
  const navigate = useNavigate();

  const [show, setShow] = useState(false);
  const [toggleValue, setToggleValue] = useState(false);
  const [aadhar, setAadhar] = useState(null);
  const [aadharBack, setAadharBack] = useState(null);
  const [pan, setPan] = useState(null);
  const [bank, setBank] = useState(null);
  const [profilePicture, setProfilePicture] = useState("");
  const [showPdfModal, setShowPdfModal] = useState(false);
  const [fileupload, setfileupload] = useState(false);
  const [pdfUrl, setPdfUrl] = useState("");
  const [productData, setProductData] = useState({
    name: "",
    email: "",
    number: "",
    city: "",
    state: "",
    zip: "",
    address: "",
    bankName: "",
    branchName: "",
    aadharNumber: "",
    panNumber: "",
  });

  const [allFiles, setAllFiles] = useState({
    bankFile: "",
    aadharFontFile: "",
    aadharBackFile: "",
    panFile: "",
  });

  const [errors, setErrors] = useState({
    name: "",
    email: "",
    number: "",
    city: "",
    state: "",
    zip: "",
    address: "",
    aadharNumber: "",
    panNumber: "",
    bankName: "",
    branchName: "",
    accountNumber: "",
    ifscCode: "",
  });

  const [userInfo, setUserInfo] = useState({
    id: null,
    number: "",
    zip: "",
    city: "",
    state: "",
    // pincode: '',
    address: "",
    aadharNumber: "",
    aadharfrontFile: "",
    aadharbackFile: null,
    bankName: "",
    branchName: "",
    accountNumber: "",
    ifscCode: "",
    bankFile: "",
    panNumber: "",
    panFile: "",
  });

  const fileInputRef = useRef(null);

  const changeProfile = () => {
    fileInputRef.current.click();
  };

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      navigate("/login");
    }
  }, [navigate]);

  const handleFileChange = async (event) => {
    const file = event.target.files[0];

    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setProfilePicture(reader.result); // Show preview immediately
      };
      reader.readAsDataURL(file);

      const formData = new FormData();
      formData.append("image", file);

      try {
        const response = await axios.post(
          `${process.env.REACT_APP_API_URL}dashbord/profile_photo_update`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );

        if (response.status === 201 && response.data.image) {
          toast.success("Profile photo updated successfully");

          let updatedProfilePhoto = response.data.image

          const urlArr = updatedProfilePhoto.split("/")

          if (urlArr[2] === "backend.clicktokart.in") {
            updatedProfilePhoto = updatedProfilePhoto.replace("/upload/profilephoto/", "/src/upload/profilephoto/");
          }

          setProfilePicture(updatedProfilePhoto);
          fetchUser(localStorage.getItem("token"));

        } else {
          toast.warn(response.data.message);
        }
      } catch (error) {
        toast.error("Error updating profile picture.");
      }
    }
  };

  useEffect(() => {
    if (auth?.user) {
      setProductData({
        name: auth.user.name || "",
        email: auth.user.email || "",
        number: auth.user.number || "",
        city: auth.user.address?.city || "",
        state: auth.user.address?.state || "",
        zip: auth.user.address?.pincode || "",
        address: auth.user.address?.full_address || "",
        aadhar_no: auth.user.aadharCardInfo?.aadharNumber || "",
        pan_no: auth.user.panCardInfo?.panNumber || "",
      });
      if (auth?.user?.profilePhoto && !profilePicture) {

        let profilePhotoUrl = auth.user.profilePhoto;

        const urlArr = profilePhotoUrl.split("/")

        if (urlArr[2] === "backend.clicktokart.in") {
          profilePhotoUrl = profilePhotoUrl.replace("/upload/profilephoto/", "/src/upload/profilephoto/");
        }

        setProfilePicture(profilePhotoUrl);
      }
      if (auth?.user?.isLock === 1) {
        toast.warn("Documents are locked and cannot be updated.");
      }
      if (auth?.user?.isReset !== 1) {
        setfileupload(false);
        localStorage.removeItem("fileupload");
      }
    }
  }, [auth?.user, profilePicture]);
  useEffect(() => {
    // Retrieve fileupload status from localStorage
    const storedFileUpload = localStorage.getItem("fileupload");

    if (storedFileUpload === "true") {
      setfileupload(true);
    }

    if (auth?.user) {
      if (fileupload) {
        toast.info("Your documents are under review.");
      } else if (auth?.user?.isReset === 1) {
        toast.warn("Documents unapproved. Please revise and resubmit.");
      }
    }
  }, [auth?.user, fileupload]);

  const handleInputChange = (e) => {
    const { type, name, value, files } = e.target;

    let error = "";

    switch (name) {
      case "number":
        const phoneNumberPattern = /^[0-9]{10}$/;
        if (!phoneNumberPattern.test(value)) {
          error = "Please enter a valid 10-digit phone number.";
        }
        break;
      case "email":
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailPattern.test(value)) {
          error = "Please enter a valid email address.";
        }
        break;
      case "aadharNumber":
        const aadharPattern = /^[0-9]{12}$/;
        if (!aadharPattern.test(value)) {
          error = "Please enter a valid 12-digit Aadhar number.";
        }
        break;
      case "panNumber":
        const panPattern = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
        if (!panPattern.test(value)) {
          error = "Please enter a valid PAN number.";
        }
        break;
      case "ifscCode":
        const ifscPattern = /^[A-Z]{4}0[A-Z0-9]{6}$/;
        if (!ifscPattern.test(value)) {
          error = "Please enter a valid IFSC code.";
        }
        break;
      case "name":
      case "bankName":
      case "branchName":
      case "city":
      case "state":
      case "address": // Allow any string in the address field
        if (!value.trim()) {
          error = "Please enter a valid address.";
        }
        break;
      case "accountNumber":
        const accountNumberPattern = /^[0-9]{12}$/;
        if (!accountNumberPattern.test(value)) {
          error =
            "Please enter a valid account number. Only numbers are allowed.";
        }
        if (value.length > 12) {
          return; // Prevent typing after 12 digits
        }
        break;
      case "zip":
        const zipPattern = /^[0-9]{6}$/;
        if (!zipPattern.test(value)) {
          error = "Please enter a valid zip code. Only numbers are allowed.";
        }
        break;
      default:
        break;
    }

    setProductData((prevData) => ({
      ...prevData,
      [name]: files ? files[0] : value,
    }));
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: error,
    }));

    if (type === "file") {
      setUserInfo((prev) => ({
        ...prev,
        [name]: files[0], // Handle file uploads
      }));
    } else {
      setUserInfo((prev) => ({
        ...prev,
        [name]: value,
      }));
    }

  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();

    // Check for validation errors
    const hasErrors = Object.values(errors).some((error) => error);
    if (hasErrors) {
      const firstError = Object.values(errors).find((error) => error); // Get the first error message
      toast.error(firstError || "Please correct the errors before submitting.");
      return;
    }

    // Append dynamic fields from productData
    Object.entries(productData).forEach(([key, value]) => {
      if (value) {
        formData.append(key, value);
      }
    });

    // Append files conditionally
    if (aadhar) formData.append("aadharfrontFile", aadhar);
    if (aadharBack) formData.append("aadharbackFile", aadharBack);
    if (bank) formData.append("bankFile", bank);
    if (pan) formData.append("panFile", pan);

    const token = localStorage.getItem("token");

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}userinfo/update`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      // Handle successful response
      if (response.status === 201) {
        toast.success(response.data.message);
        setfileupload(true);

        localStorage.setItem("fileupload", "true");
      }
      getUserInfo(); // Refresh user info
    } catch (err) {
      // Handle API errors
      if (err.response) {
        // If the server sends a response, check the error message
        const errorMessage = err.response.data.message || "An error occurred.";
        toast.error(errorMessage); // Show the server's error message
      } else {
        // If no response from the server
        toast.error("Failed to update user info. Please try again later.");
      }

      console.error("Error updating user info:", err);
    }
  };
  useEffect(() => {
    getUserInfo();
  }, []);

  const getUserInfo = async () => {
    const token = localStorage.getItem("token");

    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}userinfo/alldata`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.status === 200 && response.data) {
        setAllFiles({
          bankFile: response.data.bankFile === null ? null : `${process.env.REACT_APP_API_URL}src/upload/bankfile/${response.data.bankFile}`,
          aadharFontFile: response.data.aadharfrontFile === null ? null : `${process.env.REACT_APP_API_URL}src/upload/aadharfile/${response.data.aadharfrontFile}`,
          aadharBackFile: response.data.aadharbackFile === null ? null : `${process.env.REACT_APP_API_URL}src/upload/aadharfile/${response.data.aadharbackFile}`,
          pan: response.data.panFile === null ? null : `${process.env.REACT_APP_API_URL}src/upload/panfile/${response.data.panFile}`,
        });
        setUserInfo(response.data);
        localStorage.setItem("userInfo", JSON.stringify(response.data));
      } else {
        console.error("Failed to fetch user info or empty response data");
      }
    } catch (err) {
      console.error("Error getting user info:", err);
    }
  };

  const handlePdfOpen = (url) => {
    setPdfUrl(url);
    setShowPdfModal(true);
  };

  const closeModel = () => {
    setShowPdfModal(false);
  };

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-lg-2 p-0">
          <Sidebar
            toggleSidebar={toggleValue}
            setToggleValue={setToggleValue}
          />
        </div>
        <div className="col-lg-10 p-lg-5 p-md-4 mt-lg-5 mt-md-3 mt-3 dashboard-wrapper">
          <Icon.ArrowRight
            onClick={() => setToggleValue(true)}
            className="my-5 sidebar-open"
            color="black"
            size={30}
          ></Icon.ArrowRight>
          <div className="row dashboard-content mt-lg-0 mt-md-3 mt-3">
            <div className="col-lg-8 order-lg-1 order-2 mb-lg-0 mb-md-3 mb-3">
              <div
                className={`container-fluid bg-light p-4 ${show === true && "d-none"
                  }`}
              >
                <h2 className="fw-bold">View Profile</h2>
                <div className="form mt-5">
                  <div className="row">
                    <div className="col-12">
                      <h6 className="mb-2">
                        <strong>Name :</strong>
                        <span className="ms-2">{auth?.user?.name}</span>
                      </h6>
                      <h6 className="mb-2">
                        <strong>Email :</strong>
                        <span className="ms-2">{auth?.user?.email}</span>
                      </h6>
                      {/* <h6 className='mb-2'><strong>Contact No :</strong><span className='ms-2'>{auth?.user?.number ? auth?.user?.number : 'No contact number'}</span></h6> */}
                      <h6 className="mb-2">
                        <strong>Contact No :</strong>
                        <span className="ms-2">
                          {userInfo.number
                            ? userInfo.number
                            : "No contact number"}
                        </span>
                      </h6>
                      <h6 className="mb-2">
                        <strong>Business Volume (BV) :</strong>
                        <span className="ms-2 text-success fw-bold">
                          {auth?.user?.businessVolume || 0}
                        </span>
                      </h6>
                      {/* <h6><strong>Address :</strong><span className='ms-2'>{auth?.user?.address?.full_address ? auth?.user?.address?.full_address : 'Address is empty'}</span></h6> */}
                      <h6>
                        <strong>Address :</strong>
                        <span className="ms-2">
                          {userInfo.address
                            ? userInfo.address
                            : "Address is empty"}
                        </span>
                      </h6>
                      <Row className="mt-4">
                        <Col xs={6} md={6}>
                          <p>
                            <strong>Bank Name :</strong>
                            <span className="ms-2">
                              {userInfo.bankName
                                ? userInfo.bankName
                                : "Bank name is empty"}
                            </span>
                          </p>
                        </Col>
                        <Col xs={6} md={6}>
                          <p>
                            <strong>Branch Name :</strong>
                            <span className="ms-2">
                              {userInfo.branchName
                                ? userInfo.branchName
                                : "Branch name is empty"}
                            </span>
                          </p>
                        </Col>
                        <Col xs={6} md={6}>
                          <p>
                            <strong>IFSC Code :</strong>
                            <span className="ms-2">
                              {userInfo.ifscCode
                                ? userInfo.ifscCode
                                : "IFSC code is empty"}
                            </span>
                          </p>
                        </Col>
                        <Col xs={6} md={6}>
                          <p>
                            <strong>Account No :</strong>
                            <span className="ms-2">
                              {userInfo.accountNumber
                                ? userInfo.accountNumber
                                : "Account Number is empty"}
                            </span>
                          </p>
                        </Col>
                        <Col xs={6} md={6}>
                          <h6>
                            <strong> Bank A/C No.</strong>
                            <span className="ms-2 text-muted">
                              {userInfo.accountNumber
                                ? userInfo.accountNumber
                                : "No is empty"}
                            </span>
                          </h6>
                          {allFiles.bankFile ? (
                            <Button
                              variant="outline-primary"
                              onClick={() => handlePdfOpen(allFiles.bankFile)}
                            >
                              <FaFilePdf className="me-2" /> Bank file
                            </Button>
                          ) : (
                            <span className="text-muted">
                              No file available
                            </span>
                          )}
                        </Col>
                      </Row>
                    </div>
                    <div className="col-12">
                      <Row className="mt-4">
                        <Row>
                          <Col xs={12} md={12}>
                            <h6>
                              <strong>Aadhar No:</strong>
                              <span className="ms-2 text-muted">
                                {userInfo.aadharNumber
                                  ? userInfo.aadharNumber
                                  : "No is empty"}
                              </span>
                            </h6>
                            <Row>
                              <Col xs={6} md={6}>
                                {allFiles.aadharFontFile ? (
                                  <Button
                                    variant="outline-primary"
                                    onClick={() =>
                                      handlePdfOpen(allFiles.aadharFontFile)
                                    }
                                  >
                                    <FaFilePdf className="me-2" /> Aadhar front
                                    file
                                  </Button>
                                ) : (
                                  <span className="text-muted">
                                    No file available
                                  </span>
                                )}
                              </Col>
                              <Col xs={6} md={6}>
                                {allFiles.aadharBackFile ? (
                                  <Button
                                    variant="outline-primary"
                                    onClick={() =>
                                      handlePdfOpen(allFiles.aadharBackFile)
                                    }
                                  >
                                    <FaFilePdf className="me-2" /> Aadhar Back
                                    file
                                  </Button>
                                ) : (
                                  <span className="text-muted">
                                    No file available
                                  </span>
                                )}
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                        <Row className="mt-4">
                          <Col xs={6} md={6}>
                            <h6>
                              <strong>Pan No:</strong>
                              <span className="ms-2 text-muted">
                                {userInfo.panNumber
                                  ? userInfo.panNumber
                                  : "No is empty"}
                              </span>
                            </h6>
                            {allFiles.pan ? (
                              <Button
                                variant="outline-primary"
                                onClick={() => handlePdfOpen(allFiles.pan)}
                              >
                                <FaFilePdf className="me-2" /> Pan file
                              </Button>
                            ) : (
                              <span className="text-muted">
                                No file available
                              </span>
                            )}
                          </Col>
                        </Row>
                      </Row>
                    </div>
                    <div className="col-12 mt-3">
                      <Button
                        className="mt-4 btn btn-success"
                        onClick={() => setShow(true)}
                      >
                        Edit Details
                        <Icon.Pencil className="ms-2" />
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className={`container-fluid bg-light p-4 ${show === false && "d-none"
                  }`}
              >
                <h2 className="fw-bold">Edit Profile</h2>
                <div className="form mt-5">
                  <Form onSubmit={handleSubmit}>
                    <Row className="mb-3">
                      <Form.Group
                        as={Col}
                        md="4"
                        controlId="validationCustom01"
                      >
                        <Form.Label>Name</Form.Label>
                        <Form.Control
                          required
                          type="text"
                          placeholder="Name"
                          className="shadow-none"
                          isInvalid={!!errors.name}
                          name="name"
                          value={productData.name}
                          onChange={handleInputChange}
                          disabled={auth?.user?.isLock === 1}
                        />
                        <Form.Control.Feedback>
                          Looks good!
                        </Form.Control.Feedback>
                        <Form.Control.Feedback type="invalid">
                          {errors.name}
                        </Form.Control.Feedback>
                      </Form.Group>
                      <Form.Group
                        as={Col}
                        md="4"
                        controlId="validationCustom02"
                      >
                        <Form.Label>Email ID</Form.Label>
                        <Form.Control
                          required
                          type="email"
                          placeholder="Email"
                          className="shadow-none"
                          name="email"
                          value={productData.email}
                          disabled
                        />
                        <Form.Control.Feedback>
                          Looks good!
                        </Form.Control.Feedback>
                      </Form.Group>
                      <Form.Group
                        as={Col}
                        md="4"
                        controlId="validationCustom01"
                      >
                        <Form.Label>Phone no</Form.Label>
                        <Form.Control
                          type="number"
                          placeholder="xxxxxxxxxx"
                          className="shadow-none"
                          name="number"
                          isInvalid={!!errors.number}
                          value={userInfo.number}
                          // value={productData.number}
                          onChange={handleInputChange}
                          disabled={auth?.user?.isLock === 1}
                          required
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors.number}
                        </Form.Control.Feedback>
                        <Form.Control.Feedback>
                          Looks good!
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Row>
                    <Row className="mb-3">
                      <Form.Group
                        as={Col}
                        md="6"
                        controlId="validationCustom03"
                      >
                        <Form.Label>City</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="City"
                          className="shadow-none"
                          name="city"
                          value={userInfo.city}
                          isInvalid={!!errors.city}
                          onChange={handleInputChange}
                          disabled={auth?.user?.isLock === 1}
                          required
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors.city}
                        </Form.Control.Feedback>
                      </Form.Group>
                      <Form.Group
                        as={Col}
                        md="3"
                        controlId="validationCustom04"
                      >
                        <Form.Label>State</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="State"
                          className="shadow-none"
                          name="state"
                          isInvalid={!!errors.state}
                          value={userInfo.state}
                          onChange={handleInputChange}
                          disabled={auth?.user?.isLock === 1}
                          required
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors.state}
                        </Form.Control.Feedback>
                      </Form.Group>
                      <Form.Group
                        as={Col}
                        md="3"
                        controlId="validationCustom05"
                      >
                        <Form.Label>Zip</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Zip"
                          className="shadow-none"
                          name="zip"
                          // value={userInfo.zip}
                          value={userInfo.zip}
                          isInvalid={!!errors.zip}
                          onChange={handleInputChange}
                          disabled={auth?.user?.isLock === 1}
                          required
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors.zip}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Row>
                    <Row className="mb-3">
                      <Form.Group
                        className="mb-3"
                        controlId="exampleForm.ControlTextarea1"
                      >
                        <Form.Label>Address</Form.Label>
                        <Form.Control
                          as="textarea"
                          className="shadow-none"
                          rows={3}
                          name="address"
                          value={userInfo.address}
                          onChange={handleInputChange}
                          disabled={auth?.user?.isLock === 1}
                          required
                        />
                      </Form.Group>
                    </Row>
                    <Row className="mb-5">
                      <Form.Label>Bank details</Form.Label>
                      <Form.Group
                        as={Col}
                        md="3"
                        controlId="validationCustom03"
                      >
                        <Form.Label>Bank Name</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Bank Name"
                          className="shadow-none"
                          name="bankName"
                          // value={productData.bank_name}
                          value={userInfo.bankName}
                          isInvalid={!!errors.bankName}
                          onChange={handleInputChange}
                          disabled={auth?.user?.isLock === 1}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors.bankName}
                        </Form.Control.Feedback>
                      </Form.Group>
                      <Form.Group
                        as={Col}
                        md="3"
                        controlId="validationCustom03"
                      >
                        <Form.Label>Branch Name</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Branch Name"
                          className="shadow-none"
                          name="branchName"
                          isInvalid={!!errors.branchName}
                          // value={productData.branch_name}
                          value={userInfo.branchName}
                          onChange={handleInputChange}
                          disabled={auth?.user?.isLock === 1}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors.branchName}
                        </Form.Control.Feedback>
                      </Form.Group>
                      <Form.Group
                        as={Col}
                        md="3"
                        controlId="validationCustom03"
                      >
                        <Form.Label>Account Number</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Account Number"
                          className="shadow-none"
                          name="accountNumber"
                          // value={productData.account_number}
                          value={userInfo.accountNumber}
                          isInvalid={!!errors.accountNumber}
                          onChange={handleInputChange}
                          disabled={auth?.user?.isLock === 1}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors.accountNumber}
                        </Form.Control.Feedback>
                      </Form.Group>
                      <Form.Group
                        as={Col}
                        md="3"
                        controlId="validationCustom03"
                      >
                        <Form.Label>IFSC Code</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="IFSC Code"
                          className="shadow-none"
                          name="ifscCode"
                          // value={productData.ifsc_code}
                          value={userInfo.ifscCode}
                          onChange={handleInputChange}
                          disabled={auth?.user?.isLock === 1}
                          isInvalid={!!errors.ifscCode}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors.ifscCode}
                        </Form.Control.Feedback>
                      </Form.Group>
                      <Form.Group
                        as={Col}
                        md="12"
                        controlId="validationCustom04"
                        className="mt-3"
                      >
                        <Form.Label>Upload Bank A/C Proof</Form.Label>
                        <Form.Control
                          type="file"
                          className="shadow-none"
                          onChange={(e) => setBank(e.target.files[0])}
                          disabled={auth?.user?.isLock === 1}
                        />
                      </Form.Group>
                    </Row>
                    <Row className="mb-3">
                      <Row className="mb-3">
                        <Form.Group
                          as={Col}
                          md="4"
                          controlId="validationCustom03"
                        >
                          <Form.Label>Aadhar No.</Form.Label>
                          <Form.Control
                            type="text"
                            placeholder="xxxxxxxxxxxx"
                            className="shadow-none"
                            name="aadharNumber"
                            // value={productData.aadhar_no}
                            value={userInfo.aadharNumber}
                            onChange={handleInputChange}
                            disabled={auth?.user?.isLock === 1}
                            isInvalid={!!errors.aadharNumber}
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.aadharNumber}
                          </Form.Control.Feedback>
                        </Form.Group>
                        <Form.Group
                          as={Col}
                          md="4"
                          controlId="validationCustom04"
                        >
                          <Form.Label>Upload Aadhar Front</Form.Label>
                          <Form.Control
                            type="file"
                            className="shadow-none"
                            onChange={(e) => setAadhar(e.target.files[0])}
                            disabled={auth?.user?.isLock === 1}
                          />
                        </Form.Group>
                        <Form.Group
                          as={Col}
                          md="4"
                          controlId="validationCustom04"
                        >
                          <Form.Label>Upload Aadhar Back</Form.Label>
                          <Form.Control
                            type="file"
                            className="shadow-none"
                            onChange={(e) => setAadharBack(e.target.files[0])}
                            disabled={auth?.user?.isLock === 1}
                          />
                        </Form.Group>
                      </Row>
                      <Row className="mb-3">
                        <Form.Group
                          as={Col}
                          md="6"
                          controlId="validationCustom05"
                        >
                          <Form.Label>Pan No.</Form.Label>
                          <Form.Control
                            type="text"
                            placeholder="xxxxxxxxxxx"
                            className="shadow-none"
                            name="panNumber"
                            // value={productData.pan_no}
                            value={userInfo.panNumber}
                            onChange={handleInputChange}
                            disabled={auth?.user?.isLock === 1}
                            isInvalid={!!errors.panNumber}
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.panNumber}
                          </Form.Control.Feedback>
                        </Form.Group>
                        <Form.Group
                          as={Col}
                          md="6"
                          controlId="validationCustom06"
                        >
                          <Form.Label>Upload Pancard</Form.Label>
                          <Form.Control
                            type="file"
                            className="shadow-none"
                            onChange={(e) => setPan(e.target.files[0])}
                            disabled={auth?.user?.isLock === 1}
                          />
                        </Form.Group>
                      </Row>
                    </Row>
                    <div className="d-flex justify-content-start align-items-center mt-4">
                      <Button className="btn btn-success" type="submit">
                        Update
                        <Icon.CloudArrowUp className="ms-2" />
                      </Button>
                      <span
                        className="btn btn-dark ms-3"
                        onClick={() => setShow(false)}
                      >
                        View Details
                        <Icon.Clipboard className="ms-2" />
                      </span>
                    </div>
                  </Form>
                </div>
              </div>
            </div>
            <div className="col-lg-4 order-lg-2 order-1 mb-lg-0 mb-md-4 mb-4">
              <div className="bg-light rounded overflow-hidden shadow">
                <div className="profile-background p-5">
                  <span className="p-5"></span>
                </div>
                <div className="profile-picture border border-5 border-success">
                  {/* <img src={profilePicture} alt="" /> */}
                  {profilePicture && (
                    <img
                      src={profilePicture}
                      alt=""
                      onError={(e) => {
                        e.target.src =
                          "https://pronedvizhimost.ru/static/custom/img/default/user.png";
                      }}
                    />
                  )}
                  <span
                    className="edit-profile-picture shadow"
                    onClick={changeProfile}
                  >
                    <Icon.PencilFill></Icon.PencilFill>
                  </span>
                  <input
                    type="file"
                    ref={fileInputRef}
                    className="d-none"
                    onChange={handleFileChange}
                    disabled={auth?.user?.isLock === 1}
                  />
                </div>
                <div className="user-info text-center p-3">
                  <h2 className="mb-3">{auth?.user?.name}</h2>
                  <h4 className="mb-4">{auth?.user?.email}</h4>
                  <h6 className="text-muted">Role - {auth?.user?.userType}</h6>
                  <span
                    className={`badge rounded-pill text-bg-${auth?.user?.isActive === 1 ? "success" : "warning"
                      } mt-3`}
                  >
                    {auth?.user?.isActive === 1 ? "Active" : "Pending"}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Modal show={showPdfModal} onHide={closeModel} size="lg">
          <Modal.Header closeButton>
            <Modal.Title>PDF Viewer</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <iframe
              src={pdfUrl}
              width="100%"
              height="500px"
              style={{ border: "none" }}
              title="PDF Viewer"
            ></iframe>
          </Modal.Body>
        </Modal>

        <ToastContainer theme="dark" autoClose={2000} />
      </div>
    </div>
  );
};

export default Userprofile;